export const STORE_UPDATE_EVENT = "<|Store update|>";
